/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_PaperclipiconInputs */

const en_enum_custom_page_icon_paperclipicon = /** @type {(inputs: Enum_Custom_Page_Icon_PaperclipiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paperclip`)
};

const de_enum_custom_page_icon_paperclipicon = /** @type {(inputs: Enum_Custom_Page_Icon_PaperclipiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Büroklammer`)
};

/**
* | output |
* | --- |
* | "Paperclip" |
*
* @param {Enum_Custom_Page_Icon_PaperclipiconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_paperclipicon = /** @type {((inputs?: Enum_Custom_Page_Icon_PaperclipiconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_PaperclipiconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_paperclipicon(inputs)
	return de_enum_custom_page_icon_paperclipicon(inputs)
});